import React, { Component } from 'react';
import { Button, ButtonToolbar, ButtonGroup, FormGroup, FormControl, ControlLabel, Modal, Form, HelpBlock } from 'react-bootstrap'
import Select from "react-select";
import { PropTypes } from 'prop-types';

export class ImportProviderLaneForm extends Component {
    static contextTypes = {
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            networkEditions: [],
        };
    }

    componentDidMount() {
        this.context.addEditionObserver(this);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    updateDraftCounty(edition) {

        this.setState({
            networkEditions: edition.objects.draftNetwork
        });
    }

    onChangeFile(e) {
        const { form } = this.props;

        const uploadedFile = e.target.files[0];

        if (undefined !== uploadedFile) {
            form.file = uploadedFile;
            this.setState({
                form: form
            });
        }
    }

    onChangeDataType(dataType) {
        const { form } = this.props;

        form.dataType = dataType;

        this.setState({
            form: form
        });
    }

    // ----------------------

    renderFormDataTypes() {
        const { form } = this.props;
        return (
            <ButtonGroup style={{ marginLeft: "10px" }}>
                <Button active={8 === form.dataType} bsStyle={8 === form.dataType ? "primary" : "default"} onClick={() => this.onChangeDataType(8)}>KMZ / KML</Button>
            </ButtonGroup>
        );
    }

    render() {
        const { form } = this.props;
        const { networkEditions } = this.state;

        if (undefined === form) {
            return null;
        }

        const { show } = this.props;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formEdition" validationState={form.lane.editionInputError}>
                            <ControlLabel>Edição</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Edição"
                                noOptionsMessage={() => "Sem Edições de Rascunho Configuradas"}
                                onChange={(e) => this.props.onSelectValue(null === e ? undefined : e.id, "networkEdition")}
                                options={networkEditions}
                                isMulti={false}
                                isClearable={true}
                                getOptionValue={value => value.id}
                                getOptionLabel={label => label.name}
                                value={networkEditions.find(nEdition => nEdition.id === form.lane.obj.networkEdition)}
                            />
                            {form.lane.editionInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>
                        <FormGroup controlId="formDataFile" validationState={form.fileError}>
                            <FormControl
                                type="file"
                                placeholder="Sem Ficheiro"
                                onChange={(e) => this.onChangeFile(e, "file")}
                            />
                            {form.fileError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>
                    </Form>
                    <FormGroup>
                        <ControlLabel>Tipo de dados</ControlLabel>
                        {this.renderFormDataTypes()}
                    </FormGroup>
                    <ButtonToolbar>
                        <Button onClick={() => this.props.onImport()}> IMPORTAR </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/providerLanes/ImportProviderLaneForm.js